import { useEffect, useRef, type ReactNode } from "react";
import type { LogLine } from "../lib/types";
import { I, type IconName } from "./Icons";

export function TerminalLog({ log }: { log: LogLine[] }) {
  const bodyRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (bodyRef.current) {
      bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
    }
  }, [log]);

  return (
    <div className="gf-term">
      <div className="gf-term__head">
        <div className="gf-term__dots">
          <div className="gf-term__dot"></div>
          <div className="gf-term__dot"></div>
          <div className="gf-term__dot"></div>
        </div>
        <div className="gf-term__title">erin@nymbl ~ my-app</div>
      </div>
      <div className="gf-term__body" ref={bodyRef}>
        {log.length === 0 && (
          <div
            className="gf-term__line gf-term__line--out"
            style={{ color: "rgba(255,255,255,0.4)" }}
          >
            Run a command to see what happens, or click the buttons below.
          </div>
        )}
        {log.map((line, i) => (
          <div
            key={i}
            className={`gf-term__line gf-term__line--${line.kind}`}
          >
            {line.kind === "cmd" ? (
              <>
                <span className="gf-term__prompt">$</span>
                <span className="gf-term__cmd">{line.text}</span>
              </>
            ) : (
              line.text
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export function ActionRow({ children }: { children: ReactNode }) {
  return <div className="gf-actions">{children}</div>;
}

interface ActionProps {
  icon?: IconName;
  label: string;
  onClick?: () => void;
  disabled?: boolean;
  variant?: "primary" | "gradient";
  hint?: string;
}

export function Action({
  icon,
  label,
  onClick,
  disabled,
  variant,
  hint,
}: ActionProps) {
  const IconCmp = icon ? I[icon] : null;
  const cls = ["gf-action"];
  if (variant === "primary") cls.push("gf-action--primary");
  if (variant === "gradient") cls.push("gf-action--gradient");
  return (
    <button
      className={cls.join(" ")}
      onClick={onClick}
      disabled={disabled}
      title={hint}
    >
      {IconCmp && <IconCmp size={13} />}
      <span>{label}</span>
    </button>
  );
}
